export default "__VITE_ASSET__Cx0eRnZU__"